import { RootState } from '../../../store';
import { globalDataApi } from '../../api/globalDataApi';
import type { UserProfile } from './types';

// Minimal auth marker — present whenever a session is active.
// Equivalent to the tutorial’s selectCurrentUsername
export const selectUsername = (state: RootState): string | undefined =>
  state.auth.username;

// Reads the full UserProfile from the RTK Query cache.
//
// Calling `someEndpoint.select(someArg)` generates a new memoized selector
// that returns the query-result object for that specific cache entry.
// To generate a selector for a specific query argument, call
// `select(theQueryArg)`. Here the query arg is `{ username }`.
//
//
// This replaces the old `state.auth.user` access: our components already
// call selectUser — they don’t care whether the data comes from a slice or
// from the RTK Query cache, as long as the selector returns UserProfile | undefined.
export const selectUser = (state: RootState): UserProfile | undefined => {
  const username = selectUsername(state);
  if (!username) {
    return undefined;
  }
  return globalDataApi.endpoints.getUserDetails.select({ username })(state)
    ?.data;
};
export const selectRequiresPasswordChange = (state: RootState) =>
  state.auth.requiresPasswordChange;
